import { render, staticRenderFns } from "./ToTopPage.vue?vue&type=template&id=b5823170&"
import script from "./ToTopPage.vue?vue&type=script&lang=ts&"
export * from "./ToTopPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports